import { laravel_api } from './index'

const extendedApiSlice = laravel_api.injectEndpoints({
    endpoints: (builder) => ({
        getImpersonation: builder.query<ImpersonationResource, void>({
            query: () => ({
                url: '/api/v2/impersonation',
                method: 'GET'
            }),
            providesTags: [{ type: 'Impersonation', id: 'CURRENT' }]
        }),
        /**
         * `user_id` is the impersonation target — a resource id the backend
         * authorises. The caller's own identity always comes from the session.
         */
        startImpersonation: builder.mutation<
            ImpersonationResource,
            { user_id: string }
        >({
            query: (body) => ({
                url: '/api/v2/admin/impersonation',
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'Impersonation', id: 'CURRENT' }]
        }),
        stopImpersonation: builder.mutation<ImpersonationResource, void>({
            query: () => ({
                url: '/api/v2/impersonation',
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'Impersonation', id: 'CURRENT' }]
        })
    })
})

export const {
    useGetImpersonationQuery,
    useStartImpersonationMutation,
    useStopImpersonationMutation
} = extendedApiSlice
